import React from 'react';

export default function Loading() {
  return (
    <>
      <div className='login d-flex flex-column align-items-center'>
        <h4 className='text-light'>Aguarde...</h4>
        <div className="spinner-border text-light" role="status">
            <span className="sr-only">Loading...</span>
        </div>
      </div>
    </>
  );
}